import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { MsalAuthProvider } from './components/MsalAuthProvider';
import { AuthProvider } from './contexts/AuthContext';
import LoginPage from './components/LoginPage';
import SignupPage from './components/SignupPage';
import HomePage from './components/HomePage';
import UserSettingsPage from './components/UserSettingsPage';
import ProtectedRoute from './components/ProtectedRoute';
import { navigationService } from './services/navigationService';
import './App.css';

// Component to set up navigation service
const AppContent: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    // Set up global navigation service
    navigationService.setNavigate(navigate);
    console.log('Navigation service set up');
  }, [navigate]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route 
        path="/home" 
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute>
            <UserSettingsPage />
          </ProtectedRoute>
        } 
      />
      <Route path="/" element={<Navigate to="/home" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <MsalAuthProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <AppContent />
          </div>
        </Router>
      </AuthProvider>
    </MsalAuthProvider>
  );
}

export default App;
